'use client';
/* eslint-disable tailwindcss/no-arbitrary-value */
import React from 'react';
import { Icon } from '../components-internal/Icon';
import { getTabTarget } from '../helpers/tabTarget';
import { ComponentTopPicks } from '$/(cms)/_modules/cmsService/types';
import { FeLink } from '$/components/FeLink';
import ArrowRightAlt from '$/components/icons/ArrowRightAlt';

export const TopPicksModule: React.FC<ComponentTopPicks> = ({
  title,
  items,
}) => {
  const foundItem = items?.find((item) => item.target);
  const buttonTarget = getTabTarget(foundItem?.target);

  return (
    <div className="bg-gradient-to-r from-fill/alternative-2 to-fill/base">
      <div className="mx-auto max-w-screen-2xl p-4 lg:p-10">
        <h3 className="mhg-alpha-typography-display-2 mb-6 text-left text-text/primary md:mb-7 md:text-center lg:mb-8">
          {title}
        </h3>
        <div className="grid grid-cols-1 gap-spacing/gap/y md:grid-cols-2 lg:grid-cols-4">
          {items?.map((item) => (
            <FeLink
              key={item?.name}
              href={item?.url}
              target={buttonTarget}
              className="group flex items-center gap-1 rounded-2xl px-spacing/padding/x-sm py-spacing/padding/y-sm shadow bg-white hover:bg-buttons/primary-hover hover:text-white lg:gap-4"
            >
              {item?.icon && (
                <div className="flex size-10 min-w-10 items-center justify-center rounded-full bg-fill/primary-light text-fill/primary-dark">
                  <Icon icon={item.icon} className="w-7" />
                </div>
              )}
              <div className="flex w-full items-center justify-between">
                <h3 className="mhg-alpha-typography-button-1 font-[--font-weight-title-1] text-gray-900 group-hover:text-white">
                  {item.name}
                </h3>
                <ArrowRightAlt className="size-6" />
              </div>
            </FeLink>
          ))}
        </div>
      </div>
    </div>
  );
};
